import { z } from "zod";

export const createBusSearchSchema = (t) =>
  z
    .object({
      departureCity: z
        .object({
          value: z.string(),
          label: z.string(),
        })
        .nullable()
        .refine((city) => city !== null, {
          message: t("searchErrorsDepartureRequired"),
        }),
      returnCity: z
        .object({
          value: z.string(),
          label: z.string(),
        })
        .nullable()
        .refine((city) => city !== null, {
          message: t("searchErrorsReturnRequired"),
        }),
    })
    .refine(
      (data) => {
        if (data.departureCity && data.returnCity) {
          return data.departureCity.value !== data.returnCity.value;
        }
        return true;
      },
      {
        message: t("searchErrorsSameDepartureReturn"),
        path: ["returnCity"],
      },
    );

export default createBusSearchSchema;
